<section class="aarni-font w-full shadow border-b  py-[50px] mt-[80px]">
    <div class="container mx-auto px-4">
        <h1 class=" text-center md:text-start font-bold text-[32px]">
            {{ pageTitle }}
        </h1>

    </div>
</section>

<section class="aarni-font">
    <div class="container mx-auto flex flex-col lg:flex-row gap-8 py-12 px-4">
        <aside class="w-full lg:w-1/4 space-y-4 h-fit overflow-y-auto">
            <div class="border-t-8 border-blue-400">
                <div class="bg-white shadow border border-gray-300">
                    <h2 class="text-lg font-bold p-4">Entrepreneurship</h2>
                    <div class="">
                        <a [href]="'/about/innovation-and-entrepreneurship'"
                             [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Innovation and Entrepreneurship', 'text-blue-600 bg-white' : pageTitle !== 'Innovation and Entrepreneurship'}"
                             class="flex items-center space-x-2 p-3 w-full border-y border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Innovation and Entrepreneurship
                </span>
                        </a>
                    </div>
                </div>
            </div>
            <h2 class="text-lg font-semibold mb-4">Quick Links</h2>
            <div class="bg-white p-4 rounded-lg shadow border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/about/faculty" class="flex items-center  space-x-3 p-2 rounded-lg">
                        <div>
                        <span class="w-16 h-16 flex items-center justify-center bg-green-600 text-white rounded-full">
                            <i class="fa fa-comment text-2xl"></i>
                        </span>
                        </div>
                        <span class="text-gray-700 font-medium text-[16px] xl:text-xl">Faculty</span>
                    </a>
                </div>
            </div>

            <div class="bg-white p-4 rounded-lg shadow border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/quick-links/student-testimonial" class="flex items-center space-x-3 p-2 rounded-lg">
                        <div>
                        <span class="w-16 h-16 flex items-center justify-center bg-green-600 text-white rounded-full">
                            <i class="fa fa-comment text-2xl"></i>
                        </span>
                        </div>
                        <span class="text-gray-700 font-medium text-[16px] xl:text-xl">Testimonials</span>
                    </a>
                </div>
            </div>

            <div class="bg-white p-4 rounded-lg shadow border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/about/leadership/chancellor" class="flex items-center space-x-3 p-2 rounded-lg ">
                        <div>
            <span class="w-16 h-16 flex items-center justify-center bg-pink-600 text-white rounded-full">
                <i class="fa fa-phone text-2xl"></i>
            </span></div>
                        <span class="text-gray-700 font-medium text-[16px] xl:text-xl">Leadership</span>
                    </a>
                </div>
            </div>

            <div class="bg-white p-4 rounded-lg shadow border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/quick-links/contact-us" class="flex items-center space-x-3 p-2 rounded-lg ">
                        <div>
            <span class="w-16 h-16 flex items-center justify-center bg-pink-600 text-white rounded-full">
                <i class="fa fa-camera text-2xl"></i>
            </span></div>
                        <span class="text-gray-700 font-medium text-[16px] xl:text-xl">Contact Us</span>
                    </a>
                </div>
            </div>
        </aside>
        <div class="flex-1">
            <div class="p-12 shadow-lg border-gray-200 bg-white h-fit border">
                <h3 class="font-semibold text-[22px]">
                    {{ pageTitle }}
                </h3>
                <div class="mt-6 space-y-4 text-gray-600 text-justify">
                    <p>
                        ARNI University demonstrates a commitment to fostering innovation and entrepreneurship, as
                        evidenced by its official communications and initiatives. The university's vision emphasizes
                        continual innovation in education, research, creativity, and entrepreneurship to contribute
                        effectively to the nation's economic development.
                    </p>

                    <p>
                        Chancellor Vivek Singh has articulated a vision that extends beyond employability, aiming to
                        ignite the spirit of entrepreneurship among students. Under his leadership, ARNI University has
                        become a holistic educational ecosystem, equipping students with the tools needed to excel in
                        their chosen fields and make a lasting impact on the world.
                    </p>

                    <p>The university's approach includes a focus on building sustainable livelihoods in challenging
                        geographical regions through higher education that contributes to employability and sparks
                        entrepreneurship. This is achieved by offering a diverse array of programs, promoting
                        interdisciplinary learning, and focusing on soft skills and personality development.</p>

                    <p>ARNI University's dedication to innovation and entrepreneurship is evident through its robust
                        initiatives that blend academic excellence with practical exposure. By integrating modern
                        learning methods, national missions, and global collaborations, ARNI is nurturing future-ready
                        leaders who can ideate, innovate, and impact the world.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>
